import { WhatsAppPhone } from "@/components/marketing";
import { cn } from "@/lib/utils";
import type { CampaignExample } from "../../../../data";
import { campaignAccentClasses } from "../../campaignAccent.util";

interface WhatsAppMockProps {
  campaign: CampaignExample;
  subtitle: string;
  time: string;
}

// The campaign as a WhatsApp business message in the shared WhatsAppPhone:
// text, offer card and a (decorative) quick-reply button.
const WhatsAppMock = ({ campaign, subtitle, time }: WhatsAppMockProps) => {
  const accent = campaignAccentClasses[campaign.accent];
  return (
    <WhatsAppPhone
      chat={{
        initial: campaign.brand.initial,
        shop: campaign.brand.name,
        subtitle,
      }}
      messages={[
        {
          time,
          text: campaign.whatsApp.text,
          content: (
            <span className={cn("grid gap-0.5 rounded-[9px] px-3 py-4", accent.art)}>
              <b className="text-[1.5rem] leading-[1.05] font-extrabold tracking-[-0.02em]">
                {campaign.offer.value}
              </b>
              <span className="text-[12px] font-semibold">{campaign.offer.text}</span>
            </span>
          ),
          button: campaign.whatsApp.button,
        },
      ]}
    />
  );
};

export default WhatsAppMock;
